export const photoColumns = [
  {
    field: 'cover',
    headerName: 'Cover',
    flex: 1,
    Align: 'center',
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img className="cellImg" src={params.row.img} alt="avatar" />
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: 'photo_title',
    headerName: 'Photo Title',
    flex: 1,

    renderCell: (params) => {
      return <div> {params.row.photo_title}</div>;
    },
  },
  {
    field: 'user',
    headerName: 'User',
    flex: 1,

    renderCell: (params) => {
      return <div> {params.row.user}</div>;
    },
  },

  {
    field: 'category',
    headerName: 'Category',
    flex: 1,
    renderCell: (params) => {
      return <div> {params.row.category}</div>;
    },
  },
  {
    field: 'timeStamp',
    headerName: 'Created On',
    flex: 1,
    renderCell: (params) => {
      return <div> {params.row.timeStamp?.toDate().toString().substring(0, 25)}</div>;
    },
  },
  {
    field: 'size',
    headerName: 'Size',
    flex: 1,
    renderCell: (params) => {
      return <div> {params.row.size} MB</div>;
    },
  },
];

export const phoneColumns = [
  {
    field: 'cover',
    headerName: 'Cover',
    flex: 1,
    Align: 'center',

    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img className="cellImg" src={params.row.img} alt="avatar" />
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: 'photo_title',
    headerName: 'Photo Title',
    flex: 1,

    renderCell: (params) => {
      return <div> {params.row.photo_title}</div>;
    },
  },

  {
    field: 'category',
    headerName: 'Category',
    flex: 1,
    hide: true,
    renderCell: (params) => {
      return <div> {params.row.category}</div>;
    },
  },
  {
    field: 'timeStamp',
    headerName: 'Created On',
    flex: 1,
    hide: true,
    renderCell: (params) => {
      return <div> {params.row.timeStamp?.toDate().toString().substring(0, 25)}</div>;
    },
  },
  {
    field: 'size',
    headerName: 'Size',
    flex: 1,
    hide: true,
    renderCell: (params) => {
      return <div> {params.row.size}</div>;
    },
  },
];
